import { useContext, useEffect, useState } from "react";
import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { PEProgressBar } from "../../components/linear-progress";
import { runAuthHandler } from "../util";
import { useNavigate } from "react-router";
import { getAppAboutUsItems } from "../../api/new-api";
import AboutUsLinkContainer from "./AboutUsLinkContainer";
import { ErrorAlert } from "../../components/alerts";
import { observer } from "mobx-react";
import { CloudArrowUpIcon } from "@heroicons/react/24/solid";
import Iphone from "../../components/iphone";
import { AppAboutItem } from "../../types";

const fetchData = async ({
  setData,
  setLoading,
  setError,
}: {
  setData: any;
  setLoading: any;
  setError: any;
}) => {
  setError("");
  setLoading(true);
  try {
    const res = await getAppAboutUsItems();
    if (res?.data) {
      setData(res?.data?.appAboutItems);
    } else {
      setData([]);
    }
  } catch (error) {
    setError("Error getting mobile about us data");
  } finally {
    setLoading(false);
  }
};

const PAGE_TITLE = "Mobile About Us";

const MobileAboutUsPage = () => {
  const navigate = useNavigate();
  const userStore = useContext(UserStore);
  const { selectedVenue } = userStore;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>("");
  const [data, setData] = useState<AppAboutItem[]>([]);

  const [currentAttractors, setCurrentAttractors] = useState<any[]>();

  const getAttractors = async () => {
    fetchData({ setData, setLoading, setError });
  };
  useEffect(() => {
    setCurrentAttractors(data);
  }, [data]);

  useEffect(() => {
    runAuthHandler({ userStore, navigate });
    getAttractors();
  }, [selectedVenue]);

  const displayTextArr = data.map(({ displayText }) => displayText);

  console.log("displayTextArr", displayTextArr);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/mobile-about-us", breadcrumbName: "Mobile About Us" },
        ]}
      />
      <div className="text-3xl mb-6 text-center font-bold">{PAGE_TITLE}</div>

      {loading && <PEProgressBar />}
      <div className="my-5">
        <div className={"bg-slate-100 p-10 h-80 flex justify-center gap-10"}>
          <div className="">
            <Iphone previewItems={displayTextArr} size="small" />
          </div>

          <div
            onClick={() => navigate("/mobile-about-us/create")}
            className="hover:opacity-75 hover:cursor-pointer flex flex-col justify-center items-center border-4 p-10 text-center"
          >
            <div className="flex flex-col justify-center items-center gap-1">
              <p className="text-md font-bold">
                Click here to start adding a Mobile About Us Link
              </p>
              <CloudArrowUpIcon className={"h-10 w-10 text-blue-500"} />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">
        <div className="block w-full p-6 bg-gray-100 border border-gray-200 rounded-lg shadow">
          <h5 className="text-center mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            Showing Current
          </h5>
          <p className="text-center font-normal text-gray-700 dark:text-gray-400">
            Here are the current about us links:
          </p>

          <div className="mt-4">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
              {!loading && currentAttractors?.length === 0 && (
                <ErrorAlert message="No links found" />
              )}
              {currentAttractors?.map((val, i) => (
                <AboutUsLinkContainer
                  val={val}
                  key={i}
                  triggerUpdate={getAttractors}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default observer(MobileAboutUsPage);
